var r=function(r){var t=r.city,e=r.region,n=r.postalCode;if(!t&&!e&&!n)return"";var o="";return t&&(o=""+t),e&&(o=o?o+", "+e:""+e),n&&(o=o?o+", "+n:""+n),o};export{r as formatCityRegionPostalCode};
